import { render, staticRenderFns } from "./CardArchiveMovie.vue?vue&type=template&id=0923611a&"
import script from "./CardArchiveMovie.vue?vue&type=script&lang=ts&"
export * from "./CardArchiveMovie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports